import { Component, OnInit, Input, ViewChild, SimpleChanges, OnChanges } from '@angular/core';
import { MatSort, MatTableDataSource } from '@angular/material';

@Component({
  selector: 'app-table',
  templateUrl: './table.component.html',
  styleUrls: ['./table.component.scss']
})
export class TableComponent implements OnInit, OnChanges {

  @Input() data: Array<any>;
  @Input() keys: string[];

  datasource: MatTableDataSource<any>;
  sort: MatSort;
  // paginator: MatPaginator;

  @ViewChild(MatSort) set matSort(ms: MatSort) {
    this.sort = ms;
    this.setDataSourceAttributes();
  }

  // @ViewChild(MatPaginator) set matPaginator(mp: MatPaginator) {
  //   this.paginator = mp;
  //   this.setDataSourceAttributes();
  // }

  constructor() { }

  ngOnInit() {
    this.datasource = new MatTableDataSource (this.data);
  }
  ngOnChanges(changes: SimpleChanges) {
    this.datasource = new MatTableDataSource (changes.data.currentValue);
  }

  deleteBlock (element) { }

  setDataSourceAttributes() {
    // this.datasource.paginator = this.paginator;
    this.datasource.sort = this.sort;
  }

}
